export default __webpack_public_path__ + "static/media/button-background.7434a7b8.png";